import { DTO_Value } from './value';
import { DTO_ChangeableParameter } from './changeableParameter';

export class DTO_ChangeableSelectionParameter extends DTO_ChangeableParameter{
    value: DTO_Value[];
}